import React from "react";
import "../assets/css/About.css";
import videoBG from "../assets/mp4/about_tower.mp4";

const About = () => {

  const indicator = [
    { textOne: "+ de 30 mil", textTwo: "chamados atendidos" },
    { textOne: "+ 300 clientes", textTwo: "atendidos pelo nosso time" },
    { textOne: "+ 20 estados", textTwo: "com projetos" },
  ];


  return (
    <div className="bg-about">
    <div className="row align-items-center justify-content-xl-center   gap-16 ">

      <div className="card-about   ">
        <video width="100%" height="100%"  autoPlay loop muted >
          <source src={videoBG} type="video/mp4" />
          Seu navegador não suporta a tag de vídeo.
        </video>
      </div>

      <div className="card-indicator  ">
        <div className="title-about-right">Sobre a GAO TECH</div>
        <div className="title-about-descritions">Somos especialistas em consultoria e desenvolvimento de software há mais de 14 anos. Nosso objetivo é simplificar a vida das pessoas com a tecnologia.</div>
        <div className="title-about-descritions">Contamos com uma equipe experiente e certificada, preparada para apoiar sua empresa na implementação das soluções mais avançadas, acelerando sua transformação digital.</div>

        <div className="content-indicator">
        {indicator.map((item, index) => (
              <div key={index} className="indicator-item">
                <p className="indicator-text-one">{item.textOne}</p>
                <p className="indicator-text-two">{item.textTwo}</p>
              </div>
            ))}
        </div>
      </div>
    </div>
  </div>
  );
};

export default About;
